<template>
  <!-- FastGPT 悬浮球由 iframe.js 注入到 body，本组件仅负责挂载逻辑 -->
  <span v-show="false" v-if="showBot" class="fastgpt-bot-host" />
</template>

<script>
import { isFastGptEnabled, mountFastGptBot, unmountFastGptBot } from "@/utils/fastgptBot";
import { isCozeServiceEnabled } from "@/utils/cozeService";

/**
 * 全站 AI 客服悬浮球（FastGPT 分享链接）
 * 登录后用 userId 作为 authToken，便于商业版分享鉴权对接
 */
export default {
  name: "FastGptBot",
  computed: {
    showBot() {
      if (isCozeServiceEnabled()) return false;
      if (this.$route.meta && this.$route.meta.hideGlobalBot) return false;
      return this.enabled;
    },
    enabled() {
      return isFastGptEnabled();
    },
    authToken() {
      const u = this.$store.state.user;
      if (u && u.userId != null && u.userId !== "") {
        return String(u.userId);
      }
      return "";
    },
  },
  watch: {
    authToken() {
      this.refreshBot();
    },
    "$route.path"() {
      this.refreshBot();
    },
  },
  mounted() {
    window.addEventListener("coze-service-enabled-change", this.refreshBot);
    this.refreshBot();
  },
  beforeDestroy() {
    window.removeEventListener("coze-service-enabled-change", this.refreshBot);
    unmountFastGptBot();
    const script = document.getElementById("chatbot-iframe");
    if (script) script.remove();
  },
  methods: {
    refreshBot() {
      if (!this.showBot) {
        unmountFastGptBot();
        return;
      }
      if (!this.enabled) return;
      this.$nextTick(() => {
        mountFastGptBot(this.authToken);
      });
    },
  },
};
</script>
